import { Component, OnInit } from '@angular/core';
import { Account } from '../../../models/AccountModel';
import { AccountAssessment } from '../../../models/AssessmentModel';
import { SessionService } from '../../../services/session.service';
import { PlatformApiService, ResultFilter } from '../../../services/platform-api.service';
import { ThemeManagerService } from 'src/app/services/theme-manager.service';
import { MatDialog } from '@angular/material/dialog';
import { SupportTicketComponent } from 'src/app/shared/support.component';
import { SettingsWizardComponent } from '../../settings-wizard/settings-wizard-dialog.component';

export enum StateList {
  LOADING,
  CONTINUEASSESSMENT,
  COMPLETEDASSESSMENT,
  CLOSEASSESSMENT,
  SHOWDASHBOARD,
  VIEWRESULTS
}

@Component({
  selector: 'cw-ci-no-nav-layout',
  templateUrl: './no-nav-layout.component.html',
  styleUrls: ['./no-nav-layout.component.scss']
})
export class NoNavLayoutComponent implements OnInit {
  AVAILABLESTATES = StateList;
  currentState: StateList = StateList.LOADING;
  account: Account;
  workingAssessment: AccountAssessment;

  constructor(public _sessionService: SessionService, public themeManager: ThemeManagerService, private _platformApi: PlatformApiService, private dialog: MatDialog) { }

  ngOnInit() {
    this.account = this._sessionService.getCurrentAccount();
    this._platformApi.getAccountAssessments(this.account.id, undefined, new ResultFilter('updatedAt', 'desc')).subscribe(assessments => {
      this.workingAssessment = assessments.results[0];
      if (this.workingAssessment.scoredResultsJson) {
        this.currentState = StateList.SHOWDASHBOARD;
      } else {
        this.currentState = StateList.CONTINUEASSESSMENT;
      }
    });
  }

  onStateChange(event) {
    switch(event.state) {
      case StateList.CONTINUEASSESSMENT:
        this.workingAssessment = event.selectedAssessment;
        this.currentState = event.state;
        break;
      case StateList.CLOSEASSESSMENT:
        this.currentState = StateList.SHOWDASHBOARD
        break;
      default:
        console.log(event);
        this.currentState = event.state;
    }
  }

  openSupport() {
    const dialogRef = this.dialog.open(SupportTicketComponent, {
      panelClass: 'flush-dialog'
    });
    dialogRef.afterClosed().subscribe();
  }

  onMyProfileClicked() {
    const dialogRef = this.dialog.open(SettingsWizardComponent, {
      panelClass: 'flush-dialog',
      disableClose: true
    });
    dialogRef.afterClosed().subscribe();
  }
}
